import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import DialogTitleWithCloseButton from "../../components/DialogTitleWithCloseButton";
import EditableTextbox from "../../components/EditableTextbox";
import { useState } from "react";


export default function PaymentDialog({ onClose, defaultAmount }) {

   const [amount, setAmount] = useState(defaultAmount);

   return <Dialog open>
      <DialogTitleWithCloseButton onClose={onClose}>
         Amount
      </DialogTitleWithCloseButton>
      <DialogContent dividers>
         <EditableTextbox
            label="Amount"
            defaultValue={defaultAmount}
            value={amount}
            onChange={setAmount}
            type="number"
         />
      </DialogContent>
      <DialogActions>
         <Button onClick={() => onClose(amount)} variant="contained">
            Pay
         </Button>
      </DialogActions>
   </Dialog>
}